<template>
  <VisaForm country="thailand" :products>
    <template #visa_select="{ form }">
      <BasketFields :form :products />
      <ThailandExemptAlert :product="form.product.name" />
      <EntryFields
        v-model="form.entry"
        :date-hint="getEntryDateHint(form.product)"
        :has-crossing="form.product.name != 'thailand_5_years'"
      />
      <TermsCheckbox v-model="form.termsAgreed" />
    </template>

    <template #details="{ form }">
      <ClientFields v-model="form.client" />
      <StayAddress v-model="form.stayAddress" />
      <PassportDetailsNotes />
      <LazyApplicantInfo
        v-for="(applicant, i) in form.applicants"
        :applicant="applicant"
        :index="i"
      >
        <template #passport>
          <PassportFields v-model="applicant.passport" />
        </template>
        <template #personal>
          <ExtraNationalityFields v-model="applicant.extraNationality" />
          <CityOfBirth v-model="applicant.cityOfBirth" />
          <AddressFields v-model="applicant.address" />
          <OccupationFields v-model="applicant.occupation" />
          <FormBlock>
            <MaritalStatusSelect v-model="applicant.maritalStatus" />
          </FormBlock>
          <FormBlock>
            <EverVisitedRadio v-model="applicant.visited" />
          </FormBlock>
        </template>
      </LazyApplicantInfo>
    </template>

    <template #review />
    <template #upload />
    <template #payment />
  </VisaForm>
</template>

<script setup lang="ts">
import type { Product } from '~/types';

defineProps<{
  products: Product[];
}>();

const { tt } = useLocalization();
function getEntryDateHint(product: Product) {
  if (product.name == 'thailand_5_years') {
    return tt('estimate_entry_date_5_years_valid');
  }
}
</script>